import { useIdentity } from '@web/state/identity'
import { useState } from 'react'

/** Start the same account-bound OAuth flow from settings or an MCP connection card. */
export function GitHubConnect({
  disabled = false,
  reconnect = false,
}: {
  disabled?: boolean
  reconnect?: boolean
}) {
  const identity = useIdentity()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const userId = identity.state?.current_user?.id
  const connect = async () => {
    if (!userId) return
    setBusy(true)
    setError('')
    try {
      const current = new URL(window.location.href)
      current.searchParams.delete('github')
      const destination = current.pathname + current.search + current.hash
      const response = await fetch(
        `/v1/connections/${encodeURIComponent(userId)}/github/oauth?destination=${encodeURIComponent(destination)}`,
        { method: 'POST', credentials: 'same-origin' },
      )
      const result = await response.json().catch(() => ({}))
      if (!response.ok)
        throw new Error(
          typeof result.detail === 'string'
            ? result.detail
            : 'GitHub connection could not be started. Please try again.',
        )
      const target = new URL(result.authorization_url)
      if (
        target.origin !== 'https://github.com' ||
        target.pathname !== '/login/oauth/authorize'
      )
        throw new Error('GitHub returned an unexpected authorization address.')
      window.location.assign(target.href)
    } catch (failure) {
      setError((failure as Error).message)
      setBusy(false)
    }
  }
  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        disabled={disabled || busy || !userId}
        onClick={() => void connect()}
      >
        {busy
          ? 'Opening GitHub…'
          : reconnect
            ? 'Reconnect with GitHub'
            : 'Connect with GitHub'}
      </button>
      {error && (
        <p role="alert" className="mt-3 text-danger">
          {error}
        </p>
      )}
    </>
  )
}
